import axios from "../plugins/parseAxios";

export class MeterRecordAPI {
  static getMeterRecordsByMarket(marketId, month, year) {
    return axios.post("functions/getMeterRecordsByMarket", {
      marketId,
      month,
      year,
    });
  }
  static saveMeterRecords(marketId, month, year, data) {
    return axios.post("functions/saveMeterRecords", {
      marketId,
      month,
      year,
      data,
    });
  }
  static getLastMeterRecordsByMeters(meterIds) {
    return axios.post("functions/getLastMeterRecordsByMeters", {
      meterIds
    });
  }
}
